import { alpha, styled, TableCell, TableHead, TableSortLabel } from '@mui/material';

const StyledVisuallyHidden = styled('span')({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  top: 20,
  width: 1,
});

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  borderBottom:
    theme.palette.mode === 'dark'
      ? `1px solid ${theme.palette.divider}`
      : `2px solid ${alpha(theme.palette.text.primary, 0.4)}`,
  backgroundColor: theme.palette.background.paper,
  position: 'sticky',
  top: 0,
  zIndex: 10,
}));

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontSize: theme.spacing(2),
  padding: `6px ${theme.spacing(3)} 6px ${theme.spacing(2)}`,
  whiteSpace: 'nowrap',
  '&:last-child': {
    paddingRight: theme.spacing(2),
  },
}));

const StyledTableHeadLabel = styled('span')(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main,
  fontWeight: 700,
  marginRight: '0.625rem',
  fontSize: '0.75rem',
  whiteSpace: 'normal',
  display: 'inline-block',
  lineHeight: 1.3,
}));

const StyledTableSortLabel = styled(TableSortLabel)({
  display: 'flex',
});

export {
  StyledVisuallyHidden,
  StyledTableHead,
  StyledTableCellHead,
  StyledTableHeadLabel,
  StyledTableSortLabel,
};
